import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router'
import { useBahasa } from '../../../app/i18n'
import {
  useAktivitas, useBuatOrang, useDaftarkanAkun, useFiturTenantOleh, useJalurMasuk,
  useKoneksi, useTautTelegram, useTogglePengguna, useUbahPeran,
  useMuatKredensial, useOrangTenant, usePemakaian, usePengetahuan,
  useModelTenantOleh, usePaguOleh,
  useSetelanTenant, useTenantIni, useUbahAkun, useUbahFiturTenantOleh,
  useUbahSetelanTenant, useUbahTenant,
} from '../../../domains/tenancy/api'
import { istilah } from '../../../shared/lib/istilah'
import { sejak, setZonaTenant, tanggal, uangUSD } from '../../../shared/lib/waktu'
import {
  Angka, Baris, Bendera, Body, Chip, Gagal, Isian, KV, KVBaris, KepalaHalaman, Kosong,
  Memuat, Panel, Pilihan, Sub, Tab, Tabel, Tombol,
} from '../../../shared/ui'
import SambunganBaru from './Sambungan'
import { NADA_MODE } from './DaftarTenant'

function Galat({ m }) {
  if (!m?.isError) return null
  return (
    <Bendera nada="bad" role="alert">{m.error?.message}</Bendera>
  )
}

/** Apa yang masih kurang, dalam kalimat — datang apa adanya dari backend. */
function Kesiapan({ data, t }) {
  if (!data) return null
  if (data.siap && data.kurang.length === 0) {
    return (
      <Bendera nada="ok">{t('adm.siapPenuh')}</Bendera>
    )
  }
  return (
    <div className="flex flex-col gap-2 border border-line border-l-[3px] border-l-warn
                    bg-surface rounded-md px-3.5 py-3">
      <p className="m-0 text-[12.5px] font-semibold">
        {data.siap ? t('adm.siapTapiDibatasi') : t('adm.belumSiap')}
      </p>
      <ul className="m-0 pl-4 flex flex-col gap-1">
        {/* Kalimatnya TIDAK diterjemahkan di sini — ia datang dari backend, dan
            mencocokkan teksnya untuk menerjemahkan akan patah begitu kalimatnya
            disunting. Pola yang sama dengan pesan galat di seluruh aplikasi. */}
        {data.kurang.map((k) => (
          <li key={k} className="text-[12.5px] text-ink2">{k}</li>
        ))}
      </ul>
    </div>
  )
}

/**
 * AKUN UJI — satu-satunya isi tab ini yang tidak ada di <Sambungan>.
 *
 * Dua panel lain ("Akun platform" dan "Kredensial") DIBUANG dari sini 10 September:
 * keduanya sudah dirender <Sambungan> tepat di atasnya, jadi tab Sambungan menampilkan
 * tabel akun dua kali dan tabel kredensial dua kali — persis keluhan operator bahwa
 * "Akun Platform dan Kredensial Meta ini 2 hal yang sama". Ternyata bukan dua hal yang
 * sama; itu satu hal yang dirender dua kali.
 */
function AkunUji({ id, t, locale }) {
  const q = useKoneksi(id)
  const daftarkan = useDaftarkanAkun(id)
  const ubahAkun = useUbahAkun(id)
  const muat = useMuatKredensial(id)
  const setelan = useSetelanTenant(id)
  const ubahSetelan = useUbahSetelanTenant(id)

  const [akunBaru, setAkunBaru] = useState('')
  const [token, setToken] = useState('')
  const [ujiBaru, setUjiBaru] = useState('')

  if (q.isLoading) return <Memuat tinggi={5} />
  if (q.isError) return <Gagal galat={q.error} ulangi={q.refetch} />

  const d = q.data
  const akunUji = setelan.data?.akun_uji ?? []

  return (
    <div className="flex flex-col gap-5">
      <Kesiapan data={d} t={t} />

      {/* ── Akun platform ─────────────────────────────────────────────────── */}
      <Panel judul={t('adm.akunUji')} catatan={t('adm.akunUjiCatatan')}>
        <div className="p-3.5 flex flex-col gap-2.5 max-w-[60ch]">
          {akunUji.length > 0 ? (
            <div className="flex flex-wrap gap-1.5">
              {akunUji.map((a) => (
                <span key={a} className="inline-flex items-center gap-1.5 text-[12px]
                                         bg-surface2 border border-line rounded px-2 py-1">
                  <span className="font-mono">{a}</span>
                  <button
                    onClick={() =>
                      ubahSetelan.mutate({ akun_uji: akunUji.filter((x) => x !== a) })
                    }
                    className="text-ink3 hover:text-bad bg-transparent border-0 cursor-pointer p-0 leading-none"
                    aria-label={t('adm.hapusAkunUji')}
                  >
                    ×
                  </button>
                </span>
              ))}
            </div>
          ) : (
            <p className="m-0 text-[12.5px] text-ink2">{t('adm.akunUjiKosong')}</p>
          )}

          <div className="flex gap-2 items-end">
            <label className="flex flex-col gap-1.5 grow">
              <span className="text-[11px] font-semibold uppercase tracking-[.07em] text-ink3">
                {t('adm.tambahAkunUji')}
              </span>
              <Isian
                value={ujiBaru}
                onChange={(e) => setUjiBaru(e.target.value)}
                placeholder="@akun_uji"
              />
            </label>
            <Tombol
              jenis="sekunder"
              disabled={!ujiBaru.trim() || ubahSetelan.isPending}
              onClick={() =>
                ubahSetelan.mutate(
                  { akun_uji: [...akunUji, ujiBaru.trim()] },
                  { onSuccess: () => setUjiBaru('') },
                )
              }
            >
              {t('adm.tambah')}
            </Tombol>
          </div>
          <Galat m={ubahSetelan} />
        </div>
      </Panel>
    </div>
  )
}

export function Orang({ id, t, locale }) {
  const q = useOrangTenant(id)
  const buat = useBuatOrang(id)
  const peran = useUbahPeran(id)
  const toggle = useTogglePengguna(id)
  const taut = useTautTelegram(id)

  const [bukaBuat, setBukaBuat] = useState(false)
  // Baris yang sedang disunting — satu saja. Membuka beberapa sekaligus mengundang orang
  // menekan Simpan di baris yang salah, dan tidak ada satu pun yang mencegahnya.
  const [sunting, setSunting] = useState(null)

  if (q.isLoading) return <Memuat tinggi={4} />
  if (q.isError) return <Gagal galat={q.error} ulangi={q.refetch} />
  const items = q.data ?? []

  return (
    <>
      <Panel
        judul={t('adm.orangHitung', { n: items.length })}
        catatan={t('adm.orangCatatan')}
        aksi={
          <Tombol onClick={() => { setBukaBuat(!bukaBuat); buat.reset() }}>
            {bukaBuat ? t('umum.batal') : t('adm.tambahOrang')}
          </Tombol>
        }
      >
        {bukaBuat && (
          <FormOrang
            t={t}
            kirim={buat}
            onSelesai={() => setBukaBuat(false)}
          />
        )}

        <Tabel kepala={[t('adm.kolNama'), t('adm.kolPeran'), t('adm.kolTelegram'),
                        t('adm.kolTertaut'), t('adm.kolTerakhirAktif'), '']}>
          {items.map((o) => (
            <Baris key={o.id}>
              <td className={o.is_active ? 'font-semibold' : 'font-semibold text-ink3'}>
                {o.username}
                {!o.is_active && (
                  <span className="block text-[10.5px] font-normal text-ink3">
                    {t('adm.nonaktif')}
                  </span>
                )}
              </td>
              <td className="text-ink2">{istilah(t, 'peran', o.role)}</td>
              {/* TELEGRAM dan TERTAUT adalah DUA hal, dan rancangan memisahkannya dengan
                  benar. `telegram_username` handle yang KITA catat; `telegram_user_id`
                  lahir hanya saat orangnya sendiri menjalankan /join di grup. Satu kolom
                  gabungan menyembunyikan keadaan yang paling sering terjadi: handle-nya
                  sudah diisi, tautannya belum ada — dan orang itu tetap tidak menerima
                  notifikasi apa pun. */}
              <td className="font-mono text-[11.5px] text-ink2">
                {o.telegram_username
                  ? `@${o.telegram_username}`
                  : <span className="text-ink3">—</span>}
              </td>
              <td>
                {o.telegram_user_id
                  ? <Chip nada="ok">{t('adm.sudahJoin')}</Chip>
                  : <Chip nada="bad">{t('adm.belumJoin')}</Chip>}
              </td>
              <td className="text-[11.5px] text-ink2">
                {o.last_login_at
                  ? sejak(o.last_login_at, locale)
                  : <span className="text-ink3">{t('sis.belumPernahMasuk')}</span>}
              </td>
              <td className="text-right">
                <Tombol
                  kecil
                  jenis="sekunder"
                  onClick={() => setSunting(sunting === o.id ? null : o.id)}
                >
                  {sunting === o.id ? t('umum.tutup') : t('umum.sunting')}
                </Tombol>
              </td>
            </Baris>
          ))}
        </Tabel>

        {sunting && (
          <SuntingOrang
            t={t}
            orang={items.find((x) => x.id === sunting)}
            peran={peran}
            toggle={toggle}
            taut={taut}
            onTutup={() => setSunting(null)}
          />
        )}
      </Panel>

      <Bendera nada="info" judul={t('adm.orangSiapaJudul')} className="max-w-[80ch]">
        {t('adm.orangSiapaIsi')}
      </Bendera>
    </>
  )
}

/** Formulir tambah orang. Sandi awal DIKETIK operator, bukan dibuatkan. */
function FormOrang({ t, kirim, onSelesai }) {
  const [f, setF] = useState({ username: '', password: '', role: 'tenant_marketing',
                               telegram_username: '' })
  const bisa = f.username.trim().length > 2 && f.password.length >= 8

  return (
    <div className="p-3.5 border-b border-line flex flex-col gap-2.5 max-w-[72ch]">
      <div className="grid grid-cols-2 gap-2.5">
        {[['username', 'nama@klien.co.id', 'text'],
          ['password', '', 'password'],
          ['telegram_username', 'tanpa @', 'text']].map(([k, contoh, tipe]) => (
          <label key={k} className="flex flex-col gap-1.5">
            <span className="text-[11px] font-semibold uppercase tracking-[.07em] text-ink3">
              {t(`adm.kol${k[0].toUpperCase()}${k.slice(1)}`)}
            </span>
            <Isian
              type={tipe}
              value={f[k]}
              placeholder={contoh}
              onChange={(e) => setF({ ...f, [k]: e.target.value })}
            />
          </label>
        ))}
        <label className="flex flex-col gap-1.5">
          <span className="text-[11px] font-semibold uppercase tracking-[.07em] text-ink3">
            {t('adm.kolPeran')}
          </span>
          <Pilihan value={f.role} onChange={(e) => setF({ ...f, role: e.target.value })}>
            <option value="tenant_marketing">{t('peran.tenant_marketing')}</option>
            <option value="tenant_admin">{t('peran.tenant_admin')}</option>
          </Pilihan>
        </label>
      </div>

      {/* SANDI TIDAK DIBUATKAN LAYAR. Sandi yang dihasilkan layar harus ditampilkan untuk
          disampaikan, dan sandi yang tampil di layar masuk tangkapan layar dan riwayat
          chat. Operator mengetiknya dan menyampaikannya lewat jalur yang ia pilih. */}
      <Sub>{t('adm.sandiCatatan')}</Sub>

      <Galat m={kirim} />
      <div className="flex items-center gap-2.5">
        <Tombol
          disabled={!bisa || kirim.isPending}
          onClick={() => kirim.mutate(
            { ...f, telegram_username: f.telegram_username.trim() || null },
            { onSuccess: onSelesai },
          )}
        >
          {kirim.isPending ? t('umum.menyimpan') : t('adm.tambahOrang')}
        </Tombol>
        {!bisa && <Sub className="text-warn">{t('adm.sandiMinimal')}</Sub>}
      </div>
    </div>
  )
}

/**
 * Penyunting satu orang. TIGA tindakan, tiga rute, TIGA tombol — bukan satu "Simpan".
 *
 * Satu tombol untuk ketiganya akan mengirim tiga permintaan yang bisa gagal
 * sendiri-sendiri: peran berhasil, Telegram bentrok 409, aktif tidak tersentuh. Layar
 * lalu harus menjelaskan keadaan separuh-berubah, dan itu keadaan yang tidak perlu ada.
 */
function SuntingOrang({ t, orang, peran, toggle, taut, onTutup }) {
  const [tg, setTg] = useState(orang?.telegram_username ?? '')
  if (!orang) return null

  return (
    <div className="p-3.5 border-t border-line bg-surface2 flex flex-col gap-3
                    max-w-[72ch]">
      <b className="text-[12.5px]">{t('adm.suntingOrang', { nama: orang.username })}</b>

      <KV>
        <KVBaris label={t('adm.kolPeran')}>
          <span className="flex flex-wrap items-center gap-2">
            <Pilihan
              value={orang.role}
              disabled={peran.isPending}
              onChange={(e) => peran.mutate({ id: orang.id, role: e.target.value })}
            >
              <option value="tenant_marketing">{t('peran.tenant_marketing')}</option>
              <option value="tenant_admin">{t('peran.tenant_admin')}</option>
            </Pilihan>
          </span>
          <Galat m={peran} />
        </KVBaris>

        <KVBaris label={t('adm.kolTelegram')}>
          <span className="flex flex-wrap items-center gap-2">
            <Isian
              className="max-w-[200px]"
              value={tg}
              placeholder="tanpa @"
              onChange={(e) => setTg(e.target.value)}
            />
            <Tombol
              kecil
              jenis="sekunder"
              disabled={taut.isPending}
              onClick={() => taut.mutate({
                id: orang.id,
                // `telegram_user_id` DIPERTAHANKAN apa adanya. Rute ini menulis kedua
                // medan sekaligus, jadi mengirim handle saja akan MEMUTUS tautan yang
                // sudah jadi — orangnya berhenti menerima notifikasi tanpa ada yang
                // menyentuh tombol apa pun tentang itu.
                telegram_user_id: orang.telegram_user_id,
                telegram_username: tg.trim() || null,
              })}
            >
              {t('umum.simpan')}
            </Tombol>
          </span>
          <Sub>{t('adm.tgHandleCatatan')}</Sub>
          <Galat m={taut} />
        </KVBaris>

        <KVBaris label={t('adm.kolAkunAktif')}>
          <span className="flex flex-wrap items-center gap-2">
            <Chip nada={orang.is_active ? 'ok' : 'idle'}>
              {orang.is_active ? t('adm.aktif') : t('adm.nonaktif')}
            </Chip>
            <Tombol
              kecil
              jenis="sekunder"
              disabled={toggle.isPending}
              onClick={() => toggle.mutate(orang.id)}
            >
              {orang.is_active ? t('adm.nonaktifkan') : t('adm.aktifkan')}
            </Tombol>
          </span>
          <Galat m={toggle} />
        </KVBaris>
      </KV>

      <div>
        <Tombol kecil jenis="sekunder" onClick={onTutup}>{t('umum.tutup')}</Tombol>
      </div>
    </div>
  )
}

/**
 * IKHTISAR — tab pertama, dan yang pertama dibuka operator.
 *
 * Isinya sengaja BUKAN grafik: pertanyaan yang membawa orang ke halaman satu tenant
 * hampir selalu "kenapa yang ini bermasalah". Jadi yang ditampilkan tiga hal yang
 * menjawabnya — sambungan sudah lengkap atau belum, fitur mana yang mati, dan berapa
 * yang sudah dibelanjakan.
 */
function Ikhtisar({ id, t, locale }) {
  const koneksi = useKoneksi(id)
  const fitur = useFiturTenantOleh(id)
  const pakai = usePemakaian(id, 30)

  if (koneksi.isLoading || fitur.isLoading || pakai.isLoading) return <Memuat tinggi={5} />

  const mati = (fitur.data ?? []).filter((f) => !f.enabled)
  const d = pakai.data

  return (
    <>
      <div className="flex flex-wrap gap-2">
        <Angka label={t('adm.ikhPanggilan')} nilai={d?.total_count ?? 0} locale={locale} />
        <Angka label={t('adm.ikhToken')} nilai={d?.total_tokens ?? 0} locale={locale} />
        <Angka
          label={t('adm.ikhBiaya')}
          nilai={(d?.total_tanpa_tarif > 0 ? '≥ ' : '') + uangUSD(d?.total_cost_usd ?? 0, locale)}
          locale={locale}
        />
      </div>

      {koneksi.data?.kurang?.length > 0 && (
        <Panel judul={t('adm.ikhKurangJudul')} catatan={t('adm.ikhKurangCatatan')}>
          <ul className="m-0 p-3.5 pl-8 flex flex-col gap-1.5 text-[12.5px]">
            {koneksi.data.kurang.map((k, i) => <li key={i}>{k}</li>)}
          </ul>
        </Panel>
      )}

      <Panel judul={t('adm.ikhFiturJudul')} catatan={t('adm.ikhFiturCatatan')}>
        {mati.length === 0 ? (
          <Kosong judul={t('adm.ikhSemuaNyala')} />
        ) : (
          <div className="p-3.5 flex flex-wrap gap-1.5">
            {mati.map((f) => (
              <Chip key={f.key} nada="idle">{f.name}</Chip>
            ))}
          </div>
        )}
      </Panel>
    </>
  )
}

/** ALUR PESAN — jalur masuk, disaring ke tenant ini. Rutenya sudah ada sejak fase C;
 *  yang belum cuma pintunya dari halaman satu tenant. */
export function AlurPesan({ id, t, locale }) {
  const q = useJalurMasuk({ tenant: id, limit: 50 })
  if (q.isLoading) return <Memuat tinggi={5} />
  if (q.isError) return <Gagal galat={q.error} ulangi={q.refetch} />
  const baris = q.data?.items ?? q.data ?? []
  return (
    <Panel judul={t('adm.tabAlur')} catatan={t('adm.alurCatatan')}>
      {baris.length === 0 ? (
        <Kosong judul={t('adm.alurKosong')} keterangan={t('adm.alurKosongKet')} />
      ) : (
        <Tabel kepala={[t('adm.kolWaktu'), t('adm.kolDiterima'), t('adm.kolAkun')]}>
          {baris.map((r) => (
            <Baris key={r.id}>
              <td className="font-mono text-[11.5px] whitespace-nowrap">
                {tanggal(r.created_at, locale)}
              </td>
              <td>
                <Chip nada={r.status === 'diterima' ? 'ok' : 'warn'}>
                  {istilah(t, 'jm.status', r.status)}
                </Chip>
              </td>
              <td className="font-mono text-[11.5px] text-ink2">
                {r.external_account_id ?? '—'}
              </td>
            </Baris>
          ))}
        </Tabel>
      )}
    </Panel>
  )
}

/** PENGATURAN — dibaca saja dari konsol operator.
 *
 *  Menyuntingnya milik Tenant Admin: operator yang mengubah setelan klien tanpa klien
 *  tahu adalah perubahan yang tidak bisa dijelaskan siapa pun nanti. Yang operator
 *  butuhkan di sini cuma MELIHAT, untuk menjawab "kenapa botnya begitu". */
function Pengaturan({ id, t }) {
  const q = useSetelanTenant(id)
  if (q.isLoading) return <Memuat tinggi={5} />
  if (q.isError) return <Gagal galat={q.error} ulangi={q.refetch} />
  const d = q.data ?? {}
  const baris = [
    ['adm.setJadwal', d.scraping_schedule_label || d.scraping_schedule],
    ['adm.setTopik', (d.scraping_topics ?? []).join(', ')],
    ['adm.setBalasOtomatis', String(d.auto_reply_enabled)],
    ['adm.setAkunUji', (d.akun_uji ?? []).join(', ')],
  ]
  return (
    <Panel judul={t('adm.tabPengaturan')} catatan={t('adm.setCatatan')}>
      <Tabel kepala={[t('adm.kolSetelan'), t('adm.kolNilai')]}>
        {baris.map(([k, v]) => (
          <Baris key={k}>
            <td>{t(k)}</td>
            <td className="font-mono text-[11.5px] text-ink2">{v || '—'}</td>
          </Baris>
        ))}
      </Tabel>
    </Panel>
  )
}

/** PENGETAHUAN — judul dan keadaan, BUKAN isinya.
 *
 *  Isi dokumen bisa memuat harga, nama klien, dan syarat kontrak. Operator butuh tahu
 *  dokumen apa yang ada dan apakah aktif, bukan membacanya. */
export function Pengetahuan({ id, t }) {
  const q = usePengetahuan(id)
  if (q.isLoading) return <Memuat tinggi={5} />
  if (q.isError) return <Gagal galat={q.error} ulangi={q.refetch} />
  const baris = q.data ?? []
  return (
    <Panel judul={t('adm.tabPengetahuan')} catatan={t('adm.pengCatatan')}>
      {baris.length === 0 ? (
        <Kosong judul={t('adm.pengKosong')} keterangan={t('adm.pengKosongKet')} />
      ) : (
              <Tabel kepala={[t('adm.kolDokumen'), t('adm.kolVersi'), t('adm.kolPotongan'),
                      t('adm.kolDipakaiBot')]}>
          {baris.map((r) => (
            <Baris key={r.id}>
              <td className={r.is_active ? undefined : 'text-ink3'}>{r.source_file}</td>
              <td className="font-mono text-[11.5px] text-ink2">{r.version}</td>
              {/* POTONGAN, bukan panjang berkas. Berapa chunk yang lahir dari dokumen
                  ini menentukan apakah bot bisa memakainya; jumlah karakter tidak
                  menentukan apa pun. Nol berarti dokumennya ada dan bot tidak bisa
                  memakainya sama sekali — dan tanpa kolom ini ia terlihat PERSIS seperti
                  dokumen sehat. */}
              <td className="tabular">
                {r.potongan === 0
                  ? <Chip nada="bad">{t('adm.belumDiproses')}</Chip>
                  : r.potongan}
              </td>
              <td>
                <Chip nada={r.is_active ? 'ok' : 'idle'}>
                  {r.is_active ? t('umum.ya') : t('umum.tidak')}
                </Chip>
              </td>
            </Baris>
          ))}
        </Tabel>
      )}
    </Panel>
  )
}

/** AKTIVITAS — jejak perubahan. `old -> new` ditampilkan, karena "sesuatu berubah"
 *  tanpa menyebut dari apa jadi apa tidak menjawab pertanyaan siapa pun. */
function Aktivitas({ id, t, locale }) {
  const q = useAktivitas(id, 50)
  if (q.isLoading) return <Memuat tinggi={5} />
  if (q.isError) return <Gagal galat={q.error} ulangi={q.refetch} />
  const baris = q.data ?? []
  return (
    <Panel judul={t('adm.tabAktivitas')} catatan={t('adm.aktCatatan')}>
      {baris.length === 0 ? (
        <Kosong judul={t('adm.aktKosong')} />
      ) : (
        <Tabel kepala={[t('adm.kolWaktu'), t('adm.kolObjek'), t('adm.kolAksi'), t('adm.kolPelaku'), t('adm.kolPerubahan')]}>
          {baris.map((r) => (
            <Baris key={r.id}>
              <td className="font-mono text-[11.5px] whitespace-nowrap">
                {tanggal(r.created_at, locale)}
              </td>
              <td className="font-mono text-[11.5px] text-ink2">{r.entity_type}</td>
              <td>{r.action}</td>
              <td className="text-ink2">{r.actor ?? '—'}</td>
              <td className="font-mono text-[11px] text-ink2 max-w-[38ch] truncate">
                {ringkasBeda(r)}
              </td>
            </Baris>
          ))}
        </Tabel>
      )}
    </Panel>
  )
}

/** Ringkas `old -> new` jadi satu baris yang muat di kolom. Kunci yang berubah saja —
 *  dump lengkap di kolom tabel tidak terbaca siapa pun. */
function ringkasBeda(r) {
  const lama = r.old_value ?? {}
  const baru = r.new_value ?? {}
  const kunci = [...new Set([...Object.keys(lama), ...Object.keys(baru)])]
  const berubah = kunci.filter((k) => JSON.stringify(lama[k]) !== JSON.stringify(baru[k]))
  if (berubah.length === 0) return '—'
  return berubah.map((k) => `${k}: ${JSON.stringify(lama[k]) ?? '—'} → ${JSON.stringify(baru[k])}`).join(' · ')
}


/**
 * FITUR — apa yang tenant ini BELI, dan karena itu wewenang kita.
 *
 * Tombolnya dipindah ke sini 11 September 2026. Sebelumnya ia ada di Tenant Admin dan
 * TIDAK ada di konsol ini: klien bisa menyalakan apa pun di katalog sendiri, sementara
 * yang menjualnya harus memakai curl.
 *
 * Ketergantungan ditegakkan BACKEND, dan penolakannya ditampilkan apa adanya — ia sudah
 * berupa kalimat yang menyebut apa yang harus dilakukan ("'chatbot' membutuhkan rag").
 * Menerjemahkannya di sini akan patah begitu kalimatnya disunting.
 */
function FiturTenant({ id, t }) {
  const q = useFiturTenantOleh(id)
  const ubah = useUbahFiturTenantOleh(id)

  if (q.isLoading) return <Memuat tinggi={6} />
  if (q.isError) return <Gagal galat={q.error} ulangi={q.refetch} />

  const hidup = (q.data ?? []).filter((f) => f.enabled).length

  return (
    <>
      <Galat m={ubah} />

      <Panel
        judul={t('adm.fiturJudul')}
        catatan={t('adm.fiturCatatan', { hidup, total: (q.data ?? []).length })}
      >
        <Tabel kepala={[t('ta.kolFitur'), t('ta.kolButuh'), t('ta.kolKeadaan'), '']}>
          {(q.data ?? []).map((f) => {
            const sedang = ubah.isPending && ubah.variables?.key === f.key
            return (
              <Baris key={f.key}>
                <td>
                  <b className="block text-[13px] font-semibold">{f.name}</b>
                  <span className="font-mono text-[11px] text-ink3">{f.key}</span>
                </td>
                <td>
                  <span className="flex flex-wrap gap-1">
                    {f.butuh.length === 0 && <span className="text-ink3">—</span>}
                    {f.butuh.map((b) => (
                      <span key={b} className="font-mono text-[11px] bg-surface2
                                               border border-line rounded px-1.5 py-0.5">
                        {b}
                      </span>
                    ))}
                  </span>
                </td>
                <td>
                  <Chip nada={f.enabled ? 'ok' : 'idle'}>
                    {f.enabled ? t('ta.hidup') : t('ta.mati')}
                  </Chip>
                </td>
                <td className="text-right">
                  <Tombol
                    kecil
                    jenis={f.enabled ? 'sekunder' : 'utama'}
                    disabled={sedang}
                    onClick={() => {
                      ubah.reset()
                      ubah.mutate({ key: f.key, enabled: !f.enabled })
                    }}
                  >
                    {f.enabled ? t('ta.matikan') : t('ta.nyalakan')}
                  </Tombol>
                </td>
              </Baris>
            )
          })}
        </Tabel>
      </Panel>

      <Bendera nada="info" judul={t('adm.fiturJualJudul')} className="max-w-[80ch]">
        {t('adm.fiturJualIsi')}
      </Bendera>
    </>
  )
}


/**
 * MODEL AI & PAGU — apa yang dipakai klien ini, dan berapa habisnya.
 *
 * Tanpa panel ini operator tidak punya cara melihat keduanya tanpa MASUK ke dalam tenant
 * itu — dan ia berdiri di luar semua tenant. Rancangan 7 September sudah memuatnya; ia
 * yang paling lama hilang dari layar ini.
 *
 * Keduanya BACA-SAJA di sini. Memilih model wewenang admin tenant (ADR-054, tingkat 2),
 * dan pagu ditetapkan lewat jalur lain. Yang dikembalikan ke operator hak MELIHAT.
 */
export function ModelPagu({ id, t, locale }) {
  const model = useModelTenantOleh(id)
  const pagu = usePaguOleh(id)

  if (model.isLoading) return <Memuat tinggi={4} />
  if (model.isError) return <Gagal galat={model.error} ulangi={model.refetch} />

  const per = {}
  for (const m of model.data ?? []) (per[m.role] ??= []).push(m)
  const d = pagu.data

  return (
    <>
      <Panel judul={t('adm.modelPaguJudul')} catatan={t('adm.modelPaguCatatan')}>
        {Object.keys(per).length === 0 ? (
          <Kosong judul={t('adm.belumPilihModel')} keterangan={t('adm.belumPilihModelKet')} />
        ) : (
          <Tabel kepala={[t('kt.kolMunculDi'), t('adm.kolUrutanModel')]}>
            {Object.entries(per).map(([peran, daftar]) => (
              <Baris key={peran}>
                <td className="font-semibold">{istilah(t, 'munculDi', peran)}</td>
                {/* URUTANNYA BERARTI — yang pertama dicoba lebih dulu, dan yang berikutnya
                    dipakai kalau ia gagal (ADR-054). Menampilkannya tanpa urutan akan
                    menyembunyikan satu-satunya hal yang bisa diatur di sana. */}
                <td>
                  <span className="flex flex-wrap items-center gap-1.5">
                    {daftar.sort((a, b) => a.urutan - b.urutan).map((m, i) => (
                      <span key={m.id} className="flex items-center gap-1.5">
                        {i > 0 && <span className="text-ink3">→</span>}
                        <span className="font-mono text-[11px] bg-surface2 border border-line
                                         rounded px-1.5 py-0.5">{m.name}</span>
                        {/* Model tanpa tarif TIDAK DIHITUNG pagu sama sekali — bukan
                            dihitung nol. Operator yang melihat "12% terpakai" di panel
                            bawah berhak tahu kalau sebagian belanja tidak ikut terhitung
                            di angka itu. */}
                        {!m.tarif_diketahui && (
                          <Chip nada="warn" titik={false}
                                title={t('umum.tarifTidakDiketahuiKet')}>
                            {t('umum.tarifTidakDiketahui')}
                          </Chip>
                        )}
                      </span>
                    ))}
                  </span>
                </td>
              </Baris>
            ))}
          </Tabel>
        )}
      </Panel>

      {d && (
        <Panel judul={t('pk.bulanIni')} catatan={t('pk.hariTersisa', { n: d.hari_tersisa })}>
          <Body className="flex flex-wrap items-baseline gap-2">
            <b className="text-[19px] tabular">
              {(d.panggilan_tanpa_tarif > 0 ? '≥ ' : '') + uangUSD(d.terpakai_usd, locale)}
            </b>
            {d.pagu_bulanan_usd != null && (
              <span className="text-[13px] text-ink2">
                {t('pk.dariPagu', { pagu: uangUSD(d.pagu_bulanan_usd, locale) })}
              </span>
            )}
            <span className="flex-1" />
            {/* TANPA PAGU BUKAN NOL. Tenant tanpa pagu tidak dibatasi apa pun; "0%"
                untuknya kabar baik yang salah. */}
            <Chip nada={d.pagu_bulanan_usd == null ? 'idle'
                        : d.tahap !== 'aman' ? 'bad' : 'ok'}>
              {d.pagu_bulanan_usd == null
                ? t('pk.tanpaPagu')
                : t('pk.persenTerpakai', { n: d.persen ?? 0 })}
            </Chip>
          </Body>
          {d.dihentikan.length > 0 && (
            <Body className="border-t border-line">
              <Bendera nada="bad" role="alert">
                {t('pk.dihentikan', { daftar: d.dihentikan.join(' · ') })}
              </Bendera>
            </Body>
          )}
        </Panel>
      )}
    </>
  )
}

export default function TenantDetail() {
  const { id } = useParams()
  const { t, locale } = useBahasa()
  const [tab, setTab] = useState('ikhtisar')
  const koneksi = useKoneksi(id)
  const ubah = useUbahTenant(id)

  // ZONA TENANT INI, selama layar ini terbuka.
  //
  // Operator Smova tidak punya zona sendiri, jadi `<PenyediaZona>` melewatinya dan
  // seluruh konsol memakai bawaan. Di layar ini tenantnya SUDAH diketahui — dan
  // tanggal di bawah adalah tanggal miliknya: kapan stafnya terakhir masuk, kapan
  // dokumennya diunggah. Menampilkannya dalam zona lain berarti baris yang dibuat
  // pukul 23.30 waktu klien tertulis sehari sebelumnya, tanpa satu pun tanda.
  //
  // Dikembalikan saat keluar dari layar: daftar tenant menampilkan banyak klien
  // sekaligus, dan zona salah satunya bukan zona yang benar untuk yang lain.
  const tenantIni = useTenantIni(id)
  const zona = tenantIni.data?.timezone
  useEffect(() => {
    if (!zona) return undefined
    setZonaTenant(zona)
    return () => setZonaTenant(null)
  }, [zona])

  const mode = koneksi.data?.mode

  return (
    <>
      <KepalaHalaman
        judul={
          <span className="flex items-center gap-2.5">
            <Link to="/tenant" className="text-ink3 hover:text-ink no-underline">←</Link>
            {t('adm.detailTenant')}
          </span>
        }
        aksi={
          <Link
            to={`/tenant/${id}/onboarding`}
            className="text-[12px] font-semibold no-underline rounded border
                       px-2.5 py-1.5 bg-surface text-ink2 border-lineStrong
                       hover:text-ink hover:border-ink3"
          >
            {t('adm.keOnboarding')}
          </Link>
        }
        keterangan={id}
        aksi={
          mode ? (
            <span className="flex items-center gap-2">
              <Chip nada={NADA_MODE[mode] ?? 'idle'}>{mode}</Chip>
              <Pilihan
                value={mode}
                disabled={ubah.isPending}
                onChange={(e) => ubah.mutate({ mode: e.target.value })}
              >
                <option value="draft">draft</option>
                <option value="test">test</option>
                <option value="live">live</option>
              </Pilihan>
            </span>
          ) : null
        }
      />

      {/* Menaikkan mode mengubah siapa yang bisa menerima balasan bot. Kalau
          gagal, itu harus terbaca di sini — bukan hilang bersama chip yang tidak
          berubah. */}
      <Galat m={ubah} />

      <Tab
        aktif={tab}
        set={setTab}
        daftar={[
          { id: 'ikhtisar', label: t('adm.tabIkhtisar') },
          { id: 'koneksi', label: t('adm.tabKoneksi') },
          { id: 'alur', label: t('adm.tabAlur') },
          { id: 'orang', label: t('adm.tabOrang') },
          { id: 'fitur', label: t('adm.tabFitur') },
          { id: 'model', label: t('adm.tabModel') },
          { id: 'pengaturan', label: t('adm.tabPengaturan') },
          { id: 'pengetahuan', label: t('adm.tabPengetahuan') },
          { id: 'aktivitas', label: t('adm.tabAktivitas') },
        ]}
      />

      {tab === 'ikhtisar' && <Ikhtisar id={id} t={t} locale={locale} />}
      {tab === 'koneksi' && <><SambunganBaru id={id} t={t} locale={locale} /><AkunUji id={id} t={t} locale={locale} /></>}
      {tab === 'alur' && <AlurPesan id={id} t={t} locale={locale} />}
      {tab === 'orang' && <Orang id={id} t={t} locale={locale} />}
      {tab === 'fitur' && <FiturTenant id={id} t={t} />}
      {tab === 'model' && <ModelPagu id={id} t={t} locale={locale} />}
      {tab === 'pengaturan' && <Pengaturan id={id} t={t} locale={locale} />}
      {tab === 'pengetahuan' && <Pengetahuan id={id} t={t} locale={locale} />}
      {tab === 'aktivitas' && <Aktivitas id={id} t={t} locale={locale} />}
    </>
  )
}
